import Splide from '@splidejs/splide';

(function () {
    const updateBackLink = function () {
        const selectedTag = localStorage.getItem('selectedPaintingTag');

        if (!selectedTag) {
            return;
        }

        const backLink = document.querySelector('.painting-detail__back');

        if (!backLink) {
            return;
        }

        const backLinkUrl = new URL(backLink.href);

        if (backLinkUrl.searchParams.has('tag')) {
            return;
        }

        backLinkUrl.searchParams.set('tag', selectedTag);
        backLink.href = backLinkUrl.toString();
    };

    const initGallery = function () {
        const galleryElement = document.querySelector('[data-painting-gallery]');

        if (!galleryElement) {
            return;
        }

        const slideElements = galleryElement.querySelectorAll('[data-painting-gallery-slide]');
        const slideCount = slideElements.length;
        const hasMultipleImages = slideCount > 1;
        const splideOptions = {
            type: hasMultipleImages ? 'loop' : 'slide',
            pagination: hasMultipleImages,
            arrows: hasMultipleImages,
            keyboard: 'global',
            drag: hasMultipleImages,
            perPage: 1,
            perMove: 1,
        };

        if (hasMultipleImages) {
            splideOptions.focus = 'center';
            splideOptions.trimSpace = false;
            splideOptions.padding = {
                left: '16%',
                right: '16%',
            };
            splideOptions.breakpoints = {
                980: {
                    padding: {
                        left: '10%',
                        right: '10%',
                    },
                },
                700: {
                    padding: 0,
                },
            };
        }

        const splide = new Splide(galleryElement, splideOptions);

        splide.mount();
    };

    const init = function () {
        updateBackLink();
        initGallery();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
        return;
    }

    init();
})();